(() => {
  if(window.LuxSolAttribution)return;
  const key='luxsol_attribution_v1',age=90*86400000;
  const privacy=()=>({marketing:window.Shopify?.customerPrivacy?.marketingAllowed?.()===true,analytics:window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true});
  const safe=v=>typeof v==='string'&&v.length<=180&&!/[\u0000-\u001f<>@]/.test(v)?v:undefined;
  const id=v=>typeof v==='string'&&/^[A-Za-z0-9_.~-]{1,1500}$/.test(v)?v:undefined;
  const cookie=name=>document.cookie.split('; ').find(x=>x.startsWith(name+'='))?.slice(name.length+1);
  let memory={};const originalLinks=new WeakMap();
  function update(){
    const consent=privacy();if(!consent.marketing){memory={};try{localStorage.removeItem(key);}catch{}return;}
    try{const saved=JSON.parse(localStorage.getItem(key)||'{}');if(saved.version===1&&Date.now()-Date.parse(saved.first_touch?.at)<age)memory=saved;}catch{}
    const p=new URLSearchParams(location.search),t={at:new Date().toISOString()};
    for(const field of ['utm_source','utm_medium','utm_campaign','utm_id','utm_content','utm_term','campaign_id','adset_id','ad_id']){const v=safe(p.get(field));if(v)t[field]=v;}
    for(const field of ['gclid','gbraid','wbraid']){const v=id(p.get(field));if(v)t[field]=v;}
    if(!t.utm_source&&(t.gclid||t.gbraid||t.wbraid)){t.utm_source='google';t.utm_medium='cpc';}
    if(Object.keys(t).length>1){memory.first_touch ||= t;memory.last_touch=t;memory.version=1;try{localStorage.setItem(key,JSON.stringify(memory));}catch{}}
  }
  function snapshot(){
    update();const c=privacy(),out={version:1,consent:{...c,collected_at:new Date().toISOString()}};
    if(c.marketing){Object.assign(out,memory);const fbp=id(cookie('_fbp')),fbc=id(cookie('_fbc'));if(fbp)out.fbp=fbp;if(fbc)out.fbc=fbc;}
    if(c.analytics){const match=cookie('_ga')?.match(/^GA\d+\.\d+\.(\d+\.\d+)$/);if(match)out.client_id=match[1];}
    return out;
  }
  function decorate(){
    if(!privacy().marketing){for(const link of document.querySelectorAll('a[href*="calendly.com/luxsol-sales/"]'))if(originalLinks.has(link))link.href=originalLinks.get(link);return;}const t=snapshot().last_touch||snapshot().first_touch;if(!t)return;
    for(const link of document.querySelectorAll('a[href*="calendly.com/luxsol-sales/"]')){
      try{if(!originalLinks.has(link))originalLinks.set(link,link.href);const url=new URL(originalLinks.get(link));if(url.hostname!=='calendly.com'||!url.pathname.startsWith('/luxsol-sales/'))continue;for(const k of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'])if(t[k]&&!url.searchParams.has(k))url.searchParams.set(k,t[k]);link.href=url.href;}catch{}
    }
  }
  const receiptsKey='luxsol_attribution_privacy_receipts_v1';
  function receipts(){try{return JSON.parse(localStorage.getItem(receiptsKey)||'{}');}catch{return {};}}
  function revokeIfNeeded(){
    if(privacy().marketing||!window.fetch)return;const saved=receipts(),ids=Object.keys(saved).filter(id=>Date.now()-saved[id]<age).slice(-50);if(!ids.length)return;
    window.fetch('https://luxsol-booking-api-production.up.railway.app/api/booking/attribution/revoke',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({request_ids:ids}),keepalive:true}).then(r=>{if(r.ok)try{localStorage.removeItem(receiptsKey);}catch{}}).catch(()=>{});
  }
  function confirmed(requestId){if(!/^[0-9a-f-]{36}$/i.test(requestId||''))return;const saved=receipts();saved[requestId]=Date.now();const recent=Object.fromEntries(Object.entries(saved).filter(([,at])=>Date.now()-at<age).slice(-50));try{localStorage.setItem(receiptsKey,JSON.stringify(recent));}catch{}revokeIfNeeded();}
  window.LuxSolAttribution=Object.freeze({snapshot,confirmed});
  document.addEventListener('visitorConsentCollected',()=>{update();decorate();revokeIfNeeded();});
  const init=()=>{update();decorate();revokeIfNeeded();};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)init();});
})();

(() => {
  if (window.__luxsolSecondaryConversions) return;
  window.__luxsolSecondaryConversions = true;
  const adsId = 'AW-18243845592';
  const destinations = {
    enquiry: adsId + '/v_cUCM2GipIdENj7q_tD',
    phone: adsId + '/ytJzCNCGipIdENj7q_tD'
  };
  let configured = false;
  let lastPhoneClick = 0;
  const completed = new Set();
  const analyticsId = 'G-VPSQKZR7SM';
  let analyticsConfigured = false;
  let privacyLoading = false;
  const privacyWaiting = [];
  const privacyReady = () => typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function' && typeof window.Shopify?.customerPrivacy?.marketingAllowed === 'function';
  function withPrivacy(callback) {
    if (privacyReady()) { callback(); return; }
    if (!window.Shopify?.loadFeatures) return;
    privacyWaiting.push(callback);
    if (privacyLoading) return;
    privacyLoading = true;
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
      privacyLoading = false;
      const waiting = privacyWaiting.splice(0);
      if (!error && privacyReady()) waiting.forEach(action => action());
    });
  }
  const permitted = () => window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  const tag = function () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  };
  function configure() {
    if (!permitted()) return false;
    if (configured) return true;
    configured = true;
    tag('js', new Date());
    tag('config', adsId, {send_page_view: false, allow_ad_personalization_signals: false});
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + adsId;
      document.head.appendChild(script);
    }
    return true;
  }
  function record(kind) {
    if (!configure()) return false;
    tag('event', 'conversion', {
      send_to: destinations[kind],
      value: 0,
      currency: 'GBP',
      page_location: location.origin + location.pathname
    });
    return true;
  }
  function analytics(name, type, extra = {}) {
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return false;
    if (!analyticsConfigured) {
      analyticsConfigured = true;
      tag('config', analyticsId, {send_page_view: false});
      if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + analyticsId;
        document.head.appendChild(script);
      }
    }
    tag('event', name, {
      send_to: analyticsId,
      lead_type: type,
      ...extra,
      page_location: location.origin + location.pathname
    });
    return true;
  }
  document.addEventListener('click', event => {
    if (!event.isTrusted) return;
    const link = event.target?.closest?.('a[href^="tel:"]');
    if (!link) return;
    const phone = link.getAttribute('href').replace(/[^\d+]/g, '');
    if (!['01270346002', '+441270346002', '441270346002'].includes(phone)) return;
    const now = Date.now();
    if (now - lastPhoneClick < 1500) return;
    const sent = record('phone');
    if (analytics('luxsol_phone_click', 'phone') || sent) lastPhoneClick = now;
  }, true);
  window.addEventListener('luxsol:enquiry-success', event => {
    const type = event.detail?.type === 'callback' ? 'callback' : 'contact';
    if (completed.has(type)) return;
    completed.add(type);
    withPrivacy(() => {
      record('enquiry');
      analytics('generate_lead', type);
    });
  });
  window.addEventListener('luxsol:appointment-success', event => {
    const type = event.detail?.type;
    const eventId = event.detail?.event_id;
    const unique = typeof eventId === 'string' && /^[a-f0-9]{64}$/.test(eventId) ? eventId : type;
    if (!['video', 'showroom'].includes(type) || completed.has('appointment:' + unique)) return;
    completed.add('appointment:' + unique);
    withPrivacy(() => analytics('luxsol_appointment_booked', type, { booking_id: unique }));
  });
  document.addEventListener('visitorConsentCollected', configure);
  withPrivacy(configure);
})();
